import React, { useEffect } from "react";

import { colors } from "../config";
import pronouns from "../pronouns.js";
import "./Flag.css";

const width = 40;
const height = 24;
const pronounComponents = pronouns("400px", "400px");

const FlagFirstThree = ({
  self = ["white"],
  body = ["white"],
  pronoun = ["na"],
  hoverChevron,
  hoverPronouns,
  hoverTriangle,
  resetHover,
}) => {
  function opacityAdd(original) {
    const flagElements = [
      document.getElementById("pronounsImage"),
      document.getElementById("triangle"),
      document.getElementById("chevron"),
    ];
    flagElements.map((item, index) => {
      if (item !== original) {
        try {
          item.classList.add("opacity-hovered");
        } catch (e) {}
      }
    });
  }

  function opacityRemove(original) {
    const flagElements = [
      document.getElementById("pronounsImage"),
      document.getElementById("triangle"),
      document.getElementById("chevron"),
    ];
    flagElements.map((item, index) => {
      if (item !== original) {
        try {
          item.classList.remove("opacity-hovered");
        } catch (e) {}
      }
    });
  }

  //hovering pronouns image
  useEffect(() => {
    try {
      const pronounsImage = document.getElementById("pronounsImage");

      const handleMouseEnter = () => {
        hoverPronouns();
        opacityAdd(pronounsImage);
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        resetHover();
        opacityRemove(pronounsImage);
      };

      pronounsImage.addEventListener("mouseenter", handleMouseEnter);
      pronounsImage.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        pronounsImage.removeEventListener("mouseenter", handleMouseEnter);
        pronounsImage.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverPronouns, resetHover]);

  //hovering triangle
  useEffect(() => {
    const triangle = document.getElementById("triangle");

    const handleMouseEnter = () => {
      hoverTriangle();
      opacityAdd(triangle);
    };
    const handleMouseLeave = () => {
      // Handle mouse leave actions if needed
      // For example, you can console.log or perform other actions
      resetHover();
      opacityRemove(triangle);
    };

    triangle.addEventListener("mouseenter", handleMouseEnter);
    triangle.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      triangle.removeEventListener("mouseenter", handleMouseEnter);
      triangle.removeEventListener("mouseleave", handleMouseEnter);
    };
  }, [hoverTriangle, resetHover]);

  //hovering chevron
  useEffect(() => {
    const chevron = document.getElementById("chevron");

    const handleMouseEnter = () => {
      hoverChevron();
      opacityAdd(chevron);
    };
    const handleMouseLeave = () => {
      // Handle mouse leave actions if needed
      // For example, you can console.log or perform other actions
      resetHover();
      opacityRemove(chevron);
    };

    chevron.addEventListener("mouseenter", handleMouseEnter);
    chevron.addEventListener("mouseleave", handleMouseLeave);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      chevron.removeEventListener("mouseenter", handleMouseEnter);
      chevron.removeEventListener("mouseleave", handleMouseEnter);
    };
  }, [hoverChevron, resetHover]);

  useEffect(() => {
    try {
      const text = document.getElementById("self");
      const self = document.getElementById("triangle");

      const handleMouseEnter = () => {
        opacityAdd(self);
        hoverTriangle();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(self);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverTriangle, resetHover]);

  //text hover for sense of body
  useEffect(() => {
    try {
      const text = document.getElementById("body");
      const body = document.getElementById("chevron");

      const handleMouseEnter = () => {
        opacityAdd(body);
        hoverChevron();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(body);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverChevron, resetHover]);

  //text hover for pronouns
  useEffect(() => {
    try {
      const text = document.getElementById("pronouns");
      const pronounsImage = document.getElementById("pronounsImage");

      const handleMouseEnter = () => {
        opacityAdd(pronounsImage);
        hoverPronouns();
      };
      const handleMouseLeave = () => {
        // Handle mouse leave actions if needed
        // For example, you can console.log or perform other actions
        opacityRemove(pronounsImage);
        resetHover();
      };

      text.addEventListener("mouseenter", handleMouseEnter);
      text.addEventListener("mouseleave", handleMouseLeave);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        text.removeEventListener("mouseenter", handleMouseEnter);
        text.removeEventListener("mouseleave", handleMouseLeave);
      };
    } catch (e) {}
  }, [hoverPronouns, resetHover]);

  var newArray = [];

  if (self.length === 55) {
    self.map((item, index) => {
      if (index !== 1) {
        newArray = newArray.concat(item);
      }
    });
  } else {
    self.map((item, index) => {
      if (index !== 0) {
        newArray = newArray.concat(self[self.length - (index + 1)]);
      }
    });
  }
  self = self.concat(newArray);

  const pronounSymbol = (selected) => {
    let symbol = null;
    const asString = selected.sort().join("_");

    if (selected.includes("na")) {
      symbol = pronounComponents["na"];
    } else {
      symbol = pronounComponents[asString];
    }

    return symbol;
  };

  const selfStripes = self.map((color, i, s) => (
    <rect
      key={"self" + i}
      x={0}
      // Calculating the y position for each horizontal stripe
      y={(height * i) / s.length}
      width={width}
      // Calculating the height of each horizontal stripe
      height={height / s.length}
      // Filling the stripe with the corresponding color from the configuration
      fill={colors[color][1]}
    ></rect>
  ));
  const bodyStripes = (
    <>
      <rect
        //top
        key={1}
        x={0}
        y={4}
        width={width}
        height={1.85}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors[body[0]][0]}
      ></rect>
      <rect
        //bottom
        key={2}
        x={0}
        //   y={(height / self.length) * (2 / 3)}
        y={26.2}
        width={width}
        // height={height / 20}
        height={1.85}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors[body[0]][0]}
      ></rect>
      <rect
        //left
        key={3}
        x={0}
        //   y={(height / self.length) * (2 / 3)}
        y={4}
        width={1.85}
        // height={height / 20}
        height={height}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors[body[0]][0]}
      ></rect>
      <rect
        //right
        key={4}
        x={38.2}
        //   y={(height / self.length) * (2 / 3)}
        y={4}
        width={1.85}
        // height={height / 20}
        height={height}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors[body[0]][0]}
      ></rect>
    </>
  );

  const bodyStripesIntersex = (
    <>
      <rect
        //top purple
        key={1}
        x={0}
        y={4}
        width={width}
        height={(1.85 * 2) / 7}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["purple"][0]}
      ></rect>
      <rect
        //top yellow
        key={11}
        x={0}
        y={4 + (1.85 * 2) / 7}
        width={width}
        height={(1.85 * 3) / 7}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["yellow"][0]}
      ></rect>
      <rect
        //top purple
        key={111}
        x={0}
        y={4 + (1.85 * 5) / 7}
        width={width}
        height={(1.85 * 2) / 7}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["purple"][0]}
      ></rect>

      <rect
        //bottom purple
        key={2}
        x={0}
        y={26.2}
        width={width}
        height={(1.85 * 2) / 7}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["purple"][0]}
      ></rect>
      <rect
        //bottom yellow
        key={22}
        x={0}
        y={26.2 + (1.85 * 2) / 7}
        width={width}
        height={(1.85 * 3) / 7}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["yellow"][0]}
      ></rect>
      <rect
        //bottom purple
        key={222}
        x={0}
        y={26.2 + (1.85 * 5) / 7}
        width={width}
        height={(1.85 * 2) / 7}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["purple"][0]}
      ></rect>

      <rect
        //left purple
        key={3}
        x={0}
        y={4}
        width={(1.85 * 2) / 7}
        height={height}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["purple"][0]}
      ></rect>
      <rect
        //left yellow
        key={33}
        x={0 + (1.85 * 2) / 7}
        y={4 + (1.85 * 2) / 7}
        width={(1.85 * 3) / 7}
        height={height - (1.85 * 4) / 7}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["yellow"][0]}
      ></rect>
      <rect
        //left purple
        key={333}
        x={0 + (1.85 * 5) / 7}
        y={4 + (1.85 * 5) / 7}
        width={(1.85 * 2) / 7}
        height={height - (1.85 * 10) / 7}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["purple"][0]}
      ></rect>

      <rect
        //right purple
        key={3}
        x={38.2}
        y={4 + (1.85 * 5) / 7}
        width={(1.85 * 2) / 7}
        height={height - (1.85 * 10) / 7}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["purple"][0]}
      ></rect>
      <rect
        //right yellow
        key={33}
        x={38.2 + (1.85 * 2) / 7}
        y={4 + (1.85 * 2) / 7}
        width={(1.85 * 3) / 7}
        height={height - (1.85 * 4) / 7}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["yellow"][0]}
      ></rect>
      <rect
        //right purple
        key={333}
        x={38.2 + (1.85 * 5) / 7}
        y={4}
        width={(1.85 * 2) / 7}
        height={height}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["purple"][0]}
      ></rect>
    </>
  );

  const bodyStripesUnderneath = (
    <>
      <rect
        //top
        key={1}
        x={0}
        y={4}
        width={width}
        height={1.85}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["bg"][0]}
      ></rect>
      <rect
        //bottom
        key={1}
        x={0}
        //   y={(height / self.length) * (2 / 3)}
        y={26.2}
        width={width}
        // height={height / 20}
        height={1.85}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["bg"][0]}
      ></rect>
      <rect
        //left
        key={1}
        x={0}
        //   y={(height / self.length) * (2 / 3)}
        y={4}
        width={1.85}
        // height={height / 20}
        height={height}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["bg"][0]}
      ></rect>
      <rect
        //right
        key={1}
        x={38.2}
        //   y={(height / self.length) * (2 / 3)}
        y={4}
        width={1.85}
        // height={height / 20}
        height={height}
        // Filling the stripe with the corresponding color from the configuration
        fill={colors["bg"][0]}
      ></rect>
    </>
  );

  return (
    <div className="flag-container" border="2px solid black">
      <svg
        id={"flag"}
        className="flag"
        viewBox={`0 0 ${width} ${height}`}
        // Specifying the XML namespace for SVG
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Including horizontal and vertical stripes */}

        <svg
          id="triangle"
          viewBox={`0 0 600 600`}
          height={height * 25}
          width={width * 25}
          x={-200}
          y={0}
        >
          {selfStripes}
        </svg>
        <svg
          id="chevronUnderneath"
          viewBox={`0 0 600 600`}
          height={height * 25}
          width={width * 25}
          x={-200}
          y={-4}
        >
          {body[0] !== "white" && bodyStripesUnderneath}
        </svg>
        <svg
          id="chevron"
          viewBox={`0 0 600 600`}
          height={height * 25}
          width={width * 25}
          x={-200}
          y={-4}
        >
          {body[0] === "intersex"
            ? bodyStripesIntersex
            : body[0] !== "white" && bodyStripes}
        </svg>
        <svg
          viewBox={`0 0 600 600`}
          height={height * 2.1}
          width={width / 1}
          x={width / 6}
          y={-6.53}
          xmlns="http://www.w3.org/2000/svg"
        >
          {pronounSymbol(pronoun)}
        </svg>
      </svg>
    </div>
  );
};

export default FlagFirstThree;
